var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.counts),function(ref,i){
var count = ref.count;
var color = ref.color;
var icon = ref.icon;
var tooltip = ref.tooltip;
return _c('v-tooltip',{key:i,attrs:{"top":"","disabled":!tooltip},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('div',_vm._g(_vm._b({staticClass:"pill mr-3"},'div',attrs,false),on),[_c('div',{staticClass:"icon",class:color},[_c('v-icon',{attrs:{"color":"white","small":""}},[_vm._v(_vm._s(icon))])],1),_c('div',{staticClass:"count caption grey lighten-4 px-2 grey--text text--darken-2 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.compactCount(count))+" ")])])]}}],null,true)},[_c('span',[_vm._v(_vm._s(tooltip))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }